"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processUpdateSupplierOrderLine = void 0;
const helpers_1 = require("../../helpers");
const sendEmail_1 = require("../sendEmail");
const addOrderLog_1 = require("./addOrderLog");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderById_1 = require("./getOrderById");
const getOrderLineTitle_1 = require("./getOrderLineTitle");
const uuid_1 = require("uuid");
const processUpdateSupplierOrderLine = async (supabase, orderLineId, type, action, value) => {
    const { data, error } = await supabase
        .from("order_lines")
        .select("*, versions:order_line_versions!order_line_id(*)")
        .eq("id", orderLineId)
        .single();
    if (error) {
        throw new Error(error.message);
    }
    const order_line = data;
    const order = await (0, getOrderById_1.getOrderById)(supabase, order_line.order_id);
    let config;
    if (!order_line.versions)
        throw new Error("No versions found for order line");
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(order_line.versions);
    if (!latest_version)
        throw new Error("No versions found for order line");
    if (type === "Transfer") {
        // Get the config obj
        config = latest_version.config;
        // Get the order object
        const update = value;
        // Update the driver details
        if (action !== "CANCELLED_REJECTED") {
            config.driver = {
                name: update.name,
                phone: update.phone,
                pickup_time: update.pickup_time,
                updated_by: update.updated_by,
                updated_at: update.updated_at,
            };
            await (0, addOrderLog_1.addOrderLog)(supabase, {
                created_by: order.client?.id,
                type: "Update",
                order_id: order.id,
                detail: {
                    message: `Transfer Details Updated - (${update.name && "Name: " + update.name} ${update.pickup_time && "Pick-up Time: " + update.pickup_time} )`,
                },
            });
        }
        latest_version.config = config;
    }
    if (type === "Golf") {
        // Get the config obj
        config = latest_version.config;
        // Get the order object
        const update = value;
        let course_name = "";
        if (config.course.name) {
            course_name = config.course.name.en;
        }
        if (update.rejection) {
            latest_version.rejection_date = new Date();
            latest_version.rejection_reason = {
                type: update.rejection?.type,
                reason: update.rejection?.reason,
                rejected_by: update.updated_by,
            };
            await (0, addOrderLog_1.addOrderLog)(supabase, {
                created_by: order.client?.id,
                type: "Update",
                order_id: order.id,
                detail: {
                    message: `Tee Time at ${course_name} rejected by: ${update.updated_by} at ${config.supplier.name} (Reason: ${update.rejection?.reason})`,
                },
            });
        }
        else {
            await (0, addOrderLog_1.addOrderLog)(supabase, {
                created_by: order.client?.id,
                type: "Update",
                order_id: order.id,
                detail: {
                    message: `Tee Time at ${course_name} ${action} by: ${update.updated_by} at ${config.supplier.name}`,
                },
            });
        }
        if (update.hole_option) {
            config.hole_options.selected_option = update.hole_option;
        }
        if (update.updated_by) {
            config.tee_time.updated_by = update.updated_by;
            config.tee_time.updated_at = update.updated_at;
        }
        // update the tee times
        if (action !== "CANCELLED_REJECTED") {
            config.tee_time.groups.forEach((group, index) => {
                group.start_time = update.tee_times[index].start_time;
            });
        }
        latest_version.config = config;
    }
    latest_version.id = (0, uuid_1.v4)();
    latest_version.created_at = new Date();
    latest_version.created_by = helpers_1.ADMIN_USER_ID;
    latest_version.status = action;
    const { data: version_data, error: version_error } = await supabase
        .from("order_line_versions")
        .insert([latest_version]);
    if (!error && !version_error) {
        await (0, addOrderLog_1.addOrderLog)(supabase, {
            type: "Update",
            order_id: order_line.order_id,
            detail: {
                message: `Order Line Updated - ${(0, getOrderLineTitle_1.getOrderLineTitle)(order_line)} - (${action})`,
            },
        });
        // if (action === "ALTERNATIVE_OFFERED") {
        // }
        if (action === "CONFIRMED") {
            let email_template_id = "";
            // If confirmed and golf line send confirmation email to GOLF supplier.
            if (type === "Golf") {
                email_template_id = helpers_1.GOLF_LINE_BOOKING_CONFIRMATION_SUPPLIER;
            }
            if (type === "Transfer") {
                email_template_id = helpers_1.TRANSFER_LINE_BOOKING_CONFIRMATION_SUPPLIER;
            }
            if (email_template_id !== "") {
                const email_obj = {
                    language_code: "en",
                    template_id: email_template_id,
                    order_line_id: order_line.id,
                    order_id: order.id,
                };
                await (0, sendEmail_1.sendEmail)(email_obj);
            }
        }
        return {
            success: true,
            data: latest_version,
        };
    }
    if (version_error) {
        console.log("ERORR", version_error.message);
        throw new Error(version_error.message);
    }
};
exports.processUpdateSupplierOrderLine = processUpdateSupplierOrderLine;
